import AdvivaCore from '../../../scripts/libs/advivapress';
import Swiper, { Navigation, Pagination, Scrollbar, Thumbs, Autoplay, EffectFade} from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Thumbs, Autoplay, EffectFade]);

let ApCore = new AdvivaCore();

export default {
    init() {

        let AdvivaPress = {

            header: '#site-masthead',
            all_wrapper: '.main-wrapper',
            main:'#main',
            nav:'#header-nav',
            main_menu:'.main_menu',
            mega_menu_item: '.ap_menu-item-megamenu',
            to_top: '#toTop',
            page_slider: '.ap-slider',
            footer: '#footer',
            mobile_menu_btn: '#menu_mobile_btn',

            lg_brk: 1400,
            md_brk: 1024,
            sm_brk: 767,
            xs_brk: 576,

            init() {
                this.body = jQuery('body');
                this.wrapper = document.querySelector(this.all_wrapper);
                this.header = document.querySelector(this.header);
                this.header_nav = jQuery(this.nav);
                this.main_menu = document.querySelector(this.main_menu);
                this.mega_menu_item = document.querySelector(this.mega_menu_item);
                this.mobile_menu_btn = jQuery(this.mobile_menu_btn);
                this.footer = jQuery(this.footer);

                ApCore.init();

                ApCore.autoscrollOnHash();

                this.domManager();

                this.clickListenerManager();
            },

            /**
             *  DOM manager
             *
             */
            domManager(){
                let parent = this;

                // SET ANIMATIONS
                window.AdvivaAnimations.init();

                // MENU
                this.megaMenuManager();
                this.hoverMegaMenu();
                this.megaMenuDesktop();

                // FORMS
                ApCore.GformManager();
                jQuery(document).bind('gform_post_render', ApCore.GformManager);

                // To TOP
                ApCore.scrollToTopManager(this.to_top, 200);

                // Init Sliders
                this.initSliders();
                this.initSmartSliders();

                // column sticky
                this.columnSticky();

                // LANG
                ApCore.toggleWpmlLangSel();

                this.apTableManager();

                ApCore.replaceSVGS();


                if(!(this.header.classList.contains('sticky'))) {
                    this.header.classList.add('position-absolute');
                    this.wrapper.style.paddingTop = this.header.offsetHeight + 'px';
                }

                let initialScrollingUp = 0;
                this.body.on('advivapress.window.scroll', function () {
                    ApCore.setScrollDirection();
                    ApCore.setCurrentScrollTop();

                    // Header
                    if(window.currentScroll > parent.header.offsetHeight){
                        parent.header.classList.add('sticky-ready', 'position-fixed');
                        if(parent.header.offsetTop === 0){
                            parent.header.style.top = - parent.header.offsetHeight - 20 +'px';
                        }
                    }else{
                        parent.header.classList.remove('sticky-ready', 'position-fixed', 'header-transition');
                        parent.header.style.top = '0px';
                    }
                    if(window.isScrollingUp && window.currentScroll > parent.header.offsetHeight){
                        if (window.innerWidth <= parent.md_brk) {
                            if(initialScrollingUp === 0){
                                initialScrollingUp = window.currentScroll;
                            }
                            let scrollingUp = initialScrollingUp - window.currentScroll;
                            if(scrollingUp > 100 ){
                                parent.header.classList.add('sticky', 'header-transition');
                            }
                        } else{
                            parent.header.classList.add('sticky', 'header-transition');
                        }
                    }else{
                        initialScrollingUp = 0;
                        parent.header.classList.remove('sticky');
                    }

                    if(!parent.header.classList.contains('sticky-ready')){
                        $(window).trigger('resize');
                    }
                });

                this.body.on('advivapress.window.finalize advivapress.window.resize advivapress.window.scroll', () => {
                    if(this.main_menu){
                        if (window.innerWidth <= parent.md_brk) {
                            this.main_menu.style.top = parent.header.offsetHeight+'px';
                            this.main_menu.style.height = 'calc( 100% - '+ parent.header.offsetHeight+'px)';
                        }else{
                            this.main_menu.style.top = '';
                            this.main_menu.style.height = '';
                        }
                    }
                });

                // ON Load
                this.body.on('advivapress.window.finalize advivapress.window.resize', function(){
                    if(!(parent.header.classList.contains('sticky'))) {
                        parent.wrapper.style.paddingTop = parent.header.offsetHeight +'px';
                    }

                    // image not boxed
                    if($('.image_not_boxed').length > 0){
                        var main_width = $('#content').width();
                        $('.image_not_boxed').each(function(){
                            var container_width = $(this).closest('.row').width();
                            var image_width = $(this).width();
                            var new_image_width = ((main_width - container_width) / 2) + image_width;
                            $(this).parent('.col-inner').parent('div[class*="col-"]').addClass('ap-col-no-padding');
                            $(this).children('.bg_not_boxed_image').css('min-width', new_image_width);
                            if(window.innerWidth <= parent.md_brk && (new_image_width > container_width)){
                                $(this).children('.bg_not_boxed_image').css('min-width', 'auto');
                            }
                        });
                    }

                    parent.check_position_simple_menu();
                    parent.stickyButtonLp();

                    parent.collectionsAjaxTab();
                });

                // Resize
                this.body.on('advivapress.window.resize', function() {
                    parent.megaMenuDesktop();
                    parent.svgMask();
                });

                this.svgMask();

                // section collapse lp
                ApCore.SectionCollapse();

                this.openPopUp();

                this.anchorSidebar();

                this.textColumnReadMore();

                // FOOTER
                this.footerManager();

                this.topBarManager();

                this.search();

                this.mobileSearch();

                this.newsletterManager();
                jQuery(document).bind('gform_post_render', this.newsletterManager);

                document.addEventListener('ap_language_popup_load', () => {
                    this.languagePopup();
                });

                document.addEventListener('ap-tab-term-loaded', () => {
                    this.initSliders();
                });
            },

            /**************/

            footerManager(){
                if(window.innerWidth <= this.md_brk){
                    let footer_title = this.footer.find('.ap_footer-accordion-mobile').find('.ap_title');
                    if(footer_title.length > 0){
                        footer_title.on('click', function(){
                            $(this).toggleClass('active');
                            $(this).parent().find('.vc_wp_custommenu, .wpb_text_column').slideToggle();
                        });
                    }
                }
            },

            initSliders(){
                let parent = this;
                let sliders = document.getElementsByClassName('ap_swiper-slider');
                let thumb = '';
                Array.from(sliders).forEach((el) => {
                    if(!el.classList.contains('swiper-container-initialized')){
                        let config = window[el.dataset.sliderConfVar];
                        if(config.hasOwnProperty('thumbs') && config.thumbs.swiper === 'thumb'){
                            config.thumbs.swiper = thumb;
                            thumb = '';
                        }
                        let swiper = new Swiper('#'+el.id, config);
                        if(el.classList.contains('swiper-thumbs')){
                            thumb = swiper;
                        }
                    }
                });
            },

            initSmartSliders(){
                let parent = this;
                let customSliders = document.querySelectorAll('.ap_slider');
                customSliders.forEach((el) => {
                    let el_class = el.classList;
                    let slider_class = "ap_init-slider swiper-container ";
                    Array.from(el_class).forEach((e) => {
                        if(e.includes('ap_slider-')){
                            slider_class += e+' ';
                        }
                    });

                    let child_el = el.children;
                    (function findChild (){
                        Array.from(child_el).forEach((e, i, array) => {
                            if(e.parentNode.children.length > 1){
                                e.classList.add('swiper-slide');

                                if (i === array.length - 1){
                                    let sliderWrap = e.parentNode;
                                    let class_slider = 'ap_slider-'+Math.floor(Math.random() * 1000000);
                                    sliderWrap.classList.add(class_slider);

                                    let step = '';
                                    let breackpointInitSlider = true;
                                    let slidesPerViewXs = 1;
                                    let slidesPerViewSm = '';
                                    let slidesPerViewMd = '';
                                    let slidesPerViewLg = '';
                                    let slidesPerViewXl = '';

                                    let space = '';
                                    let slideSpaceXs = 30;
                                    let slideSpaceSm = '';
                                    let slideSpaceMd = '';
                                    let slideSpaceLg = '';
                                    let slideSpaceXl = '';


                                    slider_class = slider_class.split(" ");
                                    Array.from(slider_class).forEach((e) => {
                                        if(e !== ""){
                                            sliderWrap.classList.add(e);
                                        }
                                        if(e.includes('ap_slider-mobile-')){
                                            let breackpoint = e.split("ap_slider-mobile-").pop();
                                            if (breackpoint !== ''){
                                                breackpointInitSlider = window.innerWidth <= parent[breackpoint+'_brk'];
                                            }
                                        }
                                        if(e.includes('ap_slider-view-xl-')){
                                            step = e.split("ap_slider-view-xl-").pop();
                                            slidesPerViewXl = step;
                                        } else if(e.includes('ap_slider-view-lg-')){
                                            step = e.split("ap_slider-view-lg-").pop();
                                            slidesPerViewLg = step;
                                        } else if(e.includes('ap_slider-view-md-')){
                                            step = e.split("ap_slider-view-md-").pop();
                                            slidesPerViewMd = step;
                                        } else if(e.includes('ap_slider-view-sm-')){
                                            step = e.split("ap_slider-view-sm-").pop();
                                            slidesPerViewSm = step;
                                        } else if(e.includes('ap_slider-view-xs-')){
                                            step = e.split("ap_slider-view-xs-").pop();
                                            slidesPerViewXs = step;
                                        }

                                        if(e.includes('ap_slider-space-xl-')){
                                            space = e.split("ap_slider-space-xl-").pop();
                                            slideSpaceXl = parseInt(space);
                                        }
                                        if(e.includes('ap_slider-space-lg-')){
                                            space = e.split("ap_slider-space-lg-").pop();
                                            slideSpaceLg = parseInt(space);
                                        }
                                        if(e.includes('ap_slider-space-md-')){
                                            space = e.split("ap_slider-space-md-").pop();
                                            slideSpaceMd = parseInt(space);
                                        }
                                        if(e.includes('ap_slider-space-sm-')){
                                            space = e.split("ap_slider-space-sm-").pop();
                                            slideSpaceSm = parseInt(space);
                                        }
                                        if(e.includes('ap_slider-space-xs-')){
                                            space = e.split("ap_slider-space-xs-").pop();
                                            slideSpaceXs = parseInt(space);
                                        }

                                    });

                                    if(breackpointInitSlider){

                                        let wrapper = document.createElement('div');
                                        wrapper.classList.add('swiper-wrapper', 'justify-content-start');
                                        sliderWrap.appendChild(wrapper);

                                        let slides = el.querySelectorAll('.swiper-slide');
                                        slides.forEach((el) => {
                                            wrapper.appendChild(el);
                                        });

                                        let el_left_arrow = '';
                                        let el_right_arrow = '';
                                        let el_pagination = '';
                                        let paginationType = 'bullets';

                                        if(!sliderWrap.classList.contains('ap_slider-hide-arrow')){
                                            let left_arrow = document.createElement('div');
                                            let right_arrow = document.createElement('div');
                                            left_arrow.classList.add('swiper-button-prev');
                                            right_arrow.classList.add('swiper-button-next');
                                            sliderWrap.appendChild(left_arrow);
                                            sliderWrap.appendChild(right_arrow);

                                            el_left_arrow = sliderWrap.querySelector('.swiper-button-prev');
                                            el_right_arrow = sliderWrap.querySelector('.swiper-button-next');
                                        }

                                        if(!sliderWrap.classList.contains('ap_slider-hide-pagination')){
                                            let pagination = document.createElement('div');
                                            pagination.classList.add('swiper-pagination');
                                            let sliderWrapParent = sliderWrap.parentNode;
                                            sliderWrapParent.appendChild(pagination);

                                            el_pagination = sliderWrapParent.querySelector('.swiper-pagination');

                                            if(sliderWrap.classList.contains('ap_slider-pagination-fraction')){
                                                paginationType = 'fraction';
                                            } else if(sliderWrap.classList.contains('ap_slider-pagination-progressbar')){
                                                paginationType = 'progressbar';
                                            }
                                        }

                                        if(sliderWrap.classList.contains('ap_slider-variable-width')){
                                            slidesPerViewXl = slidesPerViewLg = slidesPerViewMd = slidesPerViewSm = slidesPerViewXs = 'auto';
                                        }

                                        if(slidesPerViewSm === ''){
                                            slidesPerViewSm = slidesPerViewXs;
                                        }
                                        if(slidesPerViewMd === ''){
                                            slidesPerViewMd = slidesPerViewSm;
                                        }
                                        if(slidesPerViewLg === ''){
                                            slidesPerViewLg = slidesPerViewMd;
                                        }
                                        if(slidesPerViewXl === ''){
                                            slidesPerViewXl = slidesPerViewLg;
                                        }

                                        if(slideSpaceSm === ''){
                                            slideSpaceSm = slideSpaceXs;
                                        }
                                        if(slideSpaceMd === ''){
                                            slideSpaceMd = slideSpaceSm;
                                        }
                                        if(slideSpaceLg === ''){
                                            slideSpaceLg = slideSpaceMd;
                                        }
                                        if(slideSpaceXl === ''){
                                            slideSpaceXl = slideSpaceLg;
                                        }

                                        let loop = false;
                                        if(sliderWrap.classList.contains('ap_slider-loop')){
                                            loop = true;
                                        }

                                        let freemode = false;
                                        if(sliderWrap.classList.contains('ap_slider-freemode')){
                                            freemode = true;
                                        }

                                        let apCenterInsufficientSlides = false;
                                        if(sliderWrap.classList.contains('ap_slider-center-insufficient-slides')){
                                            apCenterInsufficientSlides = true;
                                        }

                                        let swiper_slider = new Swiper('.'+class_slider, {
                                            slidesPerView: slidesPerViewXs,
                                            slidesPerGroup: 1,
                                            spaceBetween: slideSpaceXs,
                                            watchSlidesProgress: true,
                                            centerInsufficientSlides: apCenterInsufficientSlides,
                                            watchOverflow: true,

                                            ...((el_left_arrow !== '' && el_right_arrow !== '') && {
                                                navigation: {
                                                    prevEl: el_left_arrow,
                                                    nextEl: el_right_arrow,
                                                },
                                            }),
                                            ...(el_pagination !== '' && {
                                                pagination: {
                                                    el: el_pagination,
                                                    type: paginationType,
                                                    clickable: true,
                                                },
                                            }),
                                            freeMode: freemode,
                                            loop: loop,

                                            breakpoints: {
                                                576: {
                                                    slidesPerView: slidesPerViewSm,
                                                    spaceBetween: slideSpaceSm,
                                                },
                                                768: {
                                                    slidesPerView: slidesPerViewMd,
                                                    spaceBetween: slideSpaceMd,
                                                },
                                                1025: {
                                                    slidesPerView: slidesPerViewLg,
                                                    spaceBetween: slideSpaceLg,
                                                },
                                                1430: {
                                                    slidesPerView: slidesPerViewXl,
                                                    spaceBetween: slideSpaceXl,
                                                },
                                            },
                                        });

                                    }

                                }
                            } else{
                                child_el = e.children;
                                findChild();
                            }
                        });
                    }());

                });

            },

            // CLICK
            clickListenerManager(){
                let parent = this;

                // TO TOP
                $('#toTop').click(function(){
                    ApCore.scrollToTop();
                });

                // BOX CLICK
                $('.box-click-js').click(function(evt){
                    evt.stopPropagation();
                    evt.preventDefault();
                    evt = $(evt.currentTarget);
                    let targetAttr = evt.find('a').attr('target');
                    let url = evt.find('a').attr('href');
                    if(targetAttr === '_blank'){
                        window.open(url, '_blank');
                    } else{
                        document.location = url;
                    }
                    return false;
                });

                // Scroll to element
                $('.btn-scroll-to-element').on('click', function (e) {
                    e.preventDefault();
                    ApCore.scrollToElement($(this).attr('data-scrolltoelement'));
                });

                // VIDEO BOX PLAYER
                $('.vca_video_box .vca_video-preview').on('click', function(){
                    $(this).fadeTo(300,0,function(){
                        $(this).hide();
                        $(this).parent('.vca_video_box').addClass('start-video')
                    });
                    var data_src = $(this).parent().find('iframe').data('src');
                    $(this).parent().find('iframe').attr('src', data_src);
                });

                // FAQ
                $('.ap_faq .ap_title-faq').click(function(){
                    $(this).toggleClass('active-faq');
                    $(this).siblings('.ap_text-faq').slideToggle();
                });

                // MOBILE MENU
                this.mobile_menu_btn.click(function(){
                    parent.body.toggleClass('noScroll');

                    if (window.innerWidth <= parent.md_brk) {
                        parent.main_menu.style.top = parent.header.offsetHeight;
                        parent.main_menu.style.height = 'calc( 100% - ' + parent.header.offsetHeight + 'px)';
                    }
                    $(this).toggleClass('open');
                    parent.main_menu.classList.toggle('menu_open');
                });

                // CLICK TAB
                let tabLink = document.querySelectorAll('.vc_tta-tab a, .vc_tta-panel-title a');
                tabLink.forEach(item => {
                    item.addEventListener('click', () => {
                        setTimeout(function(){
                            window.history.pushState("", "", window.location.origin+window.location.pathname);
                        }, 0);
                    });
                });
            },

            megaMenuManager(){
                addEventListener('mousemove', () => {
                    document.querySelectorAll('.sub-menu').forEach(item => {
                        item.classList.remove('d-none');
                    });
                });

                document.querySelectorAll('.menu-item > .sub-menu').forEach(item => {
                    item.parentElement.classList.add('ap_menu-item-megamenu','simple_megamenu');
                });

                document.querySelectorAll('.main_menu .ap_menu-item-megamenu > a').forEach(item => {
                    let icon = Object.assign(document.createElement('i'), { className: 'icon-chevron-right ap_menu-arrow' });
                    item.appendChild(icon);
                });

                document.querySelectorAll('.vca_megamenu_link').forEach(item => {
                    if(item.classList.contains('active')){
                        item.closest('.ap_menu-item-megamenu').classList.add('active');
                    }
                });

                document.querySelectorAll('.ap_menu-product-category').forEach(item => {
                    let containrMenu = item.parentNode.parentNode;
                    containrMenu.classList.add('container-multilevel-product-category');
                    let colContainrMenu = containrMenu.parentNode;
                    colContainrMenu.classList.add('col-multilevel-product-category');
                });
            },

            megaMenuDesktop(){
                if(window.innerWidth > this.md_brk){
                    document.querySelectorAll('.container-multilevel-product-category:first-child, .content-multilevel-menu > .ap_menu-product-category:first-child').forEach(item => {
                        let active = item.children[0];
                        active.classList.add('active');
                    });

                    document.querySelectorAll('.col-multilevel-product-category').forEach(item => {
                        let height = item.offsetHeight;
                        let level2 = item.querySelectorAll('.content-multilevel-menu, .ap_product-preview');
                        level2.forEach(item => {
                            let level2Height = item.offsetHeight;
                            if(level2Height > height){
                                height = level2Height;
                            }
                        });
                        item.style.minHeight = height+'px';
                    });

                    let linkProducts = document.querySelectorAll('.ap_menu-link-product, .ap_menu-link-product-category');
                    linkProducts.forEach(item => {
                        item.addEventListener('mouseenter', e => {
                            linkProducts.forEach(item => {
                                item.classList.remove('active');
                            });
                            e.currentTarget.classList.add('active');
                        });
                    });

                    let productCategoriesTitle = document.querySelectorAll('.container-multilevel-product-category > .ap_megamenu-title');
                    productCategoriesTitle.forEach(item => {
                        item.addEventListener('mouseenter', e => {
                            productCategoriesTitle.forEach(item => {
                                item.classList.remove('active');
                            });
                            linkProducts.forEach(item => {
                                item.classList.remove('active');
                            });
                            e.currentTarget.classList.add('active');
                            let containerMultilevel = e.currentTarget.parentNode;
                            containerMultilevel.querySelectorAll('.content-multilevel-menu > .ap_menu-product-category:first-child > .ap_menu-link-product-category').forEach(item => {
                                item.classList.add('active');
                            });
                        });
                    });

                }
            },

            check_position_simple_menu(){
                let parent = this;
                let simple_menu = document.getElementsByClassName('simple_megamenu');
                let main_wrapper_width = this.wrapper.offsetWidth;
                Array.from(simple_menu).forEach(function(el){
                    let submenu = el.querySelector('.sub-menu');
                    let width_simple_menu = submenu.offsetWidth;
                    let offset_body_main = (window.innerWidth - main_wrapper_width) / 2;
                    let left_offset = el.getBoundingClientRect().left - offset_body_main;
                    let right_offset = main_wrapper_width - (left_offset + width_simple_menu);
                    if(right_offset < 5 && window.innerWidth > parent.md_brk){
                        submenu.style.left = 'auto';
                        submenu.style.right = '0';
                    } else {
                        submenu.style.left = '';
                        submenu.style.right = '';
                    }
                });
            },

            openPopUp(){
                $('[id*="ap_popup"]').each(function(){
                    let id = $(this).attr('id')
                    if(id.indexOf('-wrapper') > 0){
                        let $id_wrapper = $('#'+id);
                        $id_wrapper.addClass('ap_popup-form');
                        $id_wrapper.prepend('<div class="ap_close-form-sticky"><span>'+window.labels.close+'</span><i class="icon-close"></i></div>');
                        let class_click = id.replace("ap_", "").replace("-wrapper", "")
                        let $el_click = $('.ap_open-'+class_click)
                        $el_click.on('click', function(e){
                            e.preventDefault();
                            $id_wrapper.fadeIn();
                            $('body').addClass('noScroll');
                        });
                    }
                });
                $('.ap_close-form-sticky').on('click', function(){
                    $(this).parent('.ap_popup-form').fadeOut();
                    $('body').removeClass('noScroll');
                });
            },

            hoverMegaMenu(){
                if(window.innerWidth > this.md_brk){
                    document.querySelectorAll('.ap_menu-item-megamenu').forEach(item => {
                        item.addEventListener('mouseover', (event) => {
                            event.currentTarget.classList.add('open_megamenu');
                        }, false);
                        item.addEventListener('mouseout', (event) => {
                            event.currentTarget.classList.remove('open_megamenu');
                        }, false);
                    });

                    this.header.addEventListener('mouseover', (event) => {
                        event.currentTarget.classList.add('hover-header');
                    }, false);
                    this.header.addEventListener('mouseout', (event) => {
                        event.currentTarget.classList.remove('hover-header');
                    }, false);

                }else{

                    let megamenu_item = document.querySelectorAll('.ap_menu-item-megamenu > a');
                    megamenu_item.forEach(item => {
                        let item_text = item.textContent;
                        let link = item.getAttribute('href');
                        let item_link = '';
                        if(link && link !== '#'){
                            item_link = Object.assign(document.createElement('a'), { className: 'current-level-item'});
                            item_link.setAttribute('href', link);
                            item_link.innerHTML += window.labels.show;
                        }
                        let nav_menu_level = Object.assign(document.createElement('div'), { className: 'nav-menu-level' });
                        nav_menu_level.innerHTML += '<i class="icon-chevron-left"></i> '+item_text;
                        let sub = item.parentElement.getElementsByClassName('sub-menu');
                        Array.prototype.filter.call(sub, function(sub) {
                            if(link && link !== '#'){
                                sub.prepend(item_link);
                            }
                            sub.prepend(nav_menu_level);
                        });
                    });

                    let megamenu_item_level2 = document.querySelectorAll('.ap_megamenu-title > a, .ap_megamenu-title > .megamenu-title-wrap');
                    megamenu_item_level2.forEach(item => {
                        let item_text = item.textContent;
                        let link = item.getAttribute('href');
                        let item_link = '';
                        if(link && link !== '#'){
                            item_link = Object.assign(document.createElement('a'), { className: 'current-level-item'});
                            item_link.setAttribute('href', link);
                            item_link.innerHTML += window.labels.show;
                        }
                        let nav_menu_level = Object.assign(document.createElement('div'), { className: 'nav-menu-level'});
                        nav_menu_level.innerHTML += '<i class="icon-chevron-left"></i> '+item_text;
                        let sub = item.parentElement.parentElement.getElementsByClassName('content-multilevel-menu');
                        Array.prototype.filter.call(sub, function(sub) {
                            if(link && link !== '#'){
                                sub.prepend(item_link);
                            }
                            sub.prepend(nav_menu_level);
                        });
                    });

                    let megamenu_item_level3 = document.querySelectorAll('.ap_menu-product-category > a');
                    megamenu_item_level3.forEach(item => {
                        let item_text = item.textContent;
                        let link = item.getAttribute('href');
                        let item_link = '';
                        if(link && link !== '#'){
                            item_link = Object.assign(document.createElement('a'), { className: 'current-level-item'});
                            item_link.setAttribute('href', link);
                            item_link.innerHTML += window.labels.show;
                        }
                        let nav_menu_level = Object.assign(document.createElement('div'), { className: 'nav-menu-level'});
                        nav_menu_level.innerHTML += '<i class="icon-chevron-left"></i> '+item_text;
                        let sub = item.parentElement.getElementsByClassName('ap_megamenu-product-level');
                        Array.prototype.filter.call(sub, function(sub) {
                            if(link && link !== '#'){
                                sub.prepend(item_link);
                            }
                            sub.prepend(nav_menu_level);
                        });
                    });

                    let wpml_items = document.querySelectorAll('.main_menu > .wpml-ls-item');
                    if(wpml_items.length > 0){
                        let language_mobile = Object.assign(document.createElement('li'), { className: 'menu-item menu-languages wpml-ls-item wpml-ls-menu-item' });
                        wpml_items.forEach(item => {
                            if(item.classList.contains('wpml-ls-current-language')){
                                let link = item.querySelector('a');
                                link.classList.add('active');
                            }
                            language_mobile.innerHTML += item.innerHTML;
                            item.parentElement.removeChild(item);
                        });
                        this.main_menu.appendChild(language_mobile);
                    }

                    let items_parent = document.querySelectorAll('.ap_megamenu-title > a, .ap_megamenu-title > .megamenu-title-wrap, .ap_menu-item-megamenu > a, .ap_menu-link-product-category');
                    items_parent.forEach(item => {
                        item.addEventListener('click', (event) => {
                            event.preventDefault();
                            let parentClassList = event.currentTarget.parentElement.classList;
                            if(parentClassList.contains('ap_menu-item-megamenu') || parentClassList.contains('ap_menu-product-category')) {
                                parentClassList.add('open_megamenu');
                            } else{
                                event.currentTarget.closest('.container-multilevel-menu').classList.add('open_megamenu');
                            }
                        }, false);
                    });

                    let nav_menu_level = document.querySelectorAll('.nav-menu-level');
                    nav_menu_level.forEach(item => {
                        item.addEventListener('click', (event) => {
                            event.preventDefault();
                            event.currentTarget.closest('.open_megamenu').classList.remove('open_megamenu');

                        }, false);
                    });

                }
            },

            columnSticky(){
                $(".ap-column-sticky").children('.col-inner').addClass('ap-column-inner-sticky');

                var step_tablet = this.md_brk;
                var step_mobile = this.sm_brk;
                $(window).on('scroll', function(){
                    let offsetTop = $('#header-top').outerHeight() + 40;
                    if(window.innerWidth > step_tablet){
                        if($('#site-masthead').hasClass('sticky')){
                            $('.ap-column-inner-sticky').addClass('header-is-sticky');
                        } else{
                            $('.ap-column-inner-sticky').removeClass('header-is-sticky');
                        }
                        $(".ap-column-inner-sticky").stick_in_parent({
                                parent : '.ap-column-sticky',
                                offset_top: offsetTop,
                            }
                        );

                    } else{
                        $(".ap-column-inner-sticky").trigger("sticky_kit:detach");
                    }

                    if(window.innerWidth > step_mobile){
                        let nav_sidebar = $(".ap_anchor-sidebar");
                        if(nav_sidebar.length > 0){
                            nav_sidebar.stick_in_parent({
                                    parent : '#content',
                                    offset_top: offsetTop,
                                }
                            );
                        }
                    } else{
                        $(".ap_anchor-sidebar").trigger("sticky_kit:detach");
                    }
                });
            },

            anchorSidebar(){
                let parent = this;
                let sectionControllersDesktop = $('.sidebar-anchor-link');
                if(window.innerWidth > this.sm_brk && sectionControllersDesktop.length > 0){
                    sectionControllersDesktop.wrapAll('<div class="ap_anchor-sidebar w-100"><div class="container p-0"><div class="col-md-4 col-lg-3"><div class="ap_anchor-list w-100"></div></div></div></div>');

                    sectionControllersDesktop.each(function (i, el) {
                        el = $(el);
                        el.click(function (e) {
                            e.preventDefault();
                            el = $(this);
                            var sectionId = el.attr('id').replace('-controller', '');
                            ApCore.scrollToElement(sectionId);
                        });
                    });

                    let box_anchor_list = $('.ap_anchor-list');
                    $('.expandable-section').each(function(){
                        let $this = $(this);
                        let id = $this.attr('id');
                        let section_offset_top = $this.offset().top;
                        let section_height = $this.outerHeight();

                        parent.body.on('advivapress.window.finalize advivapress.window.scroll', function() {
                            activeSection();
                        });
                        function activeSection(){
                            let box_anchor_offset_top = box_anchor_list.offset().top;
                            let link = $('#'+id+'-controller');
                            if(box_anchor_offset_top >= section_offset_top && box_anchor_offset_top < section_offset_top + section_height){
                                link.addClass('active');
                            } else{
                                link.removeClass('active');
                            }
                        }
                    });
                }
            },

            textColumnReadMore(){
                let blocksText = document.querySelectorAll('.wpb_text_column');
                blocksText.forEach((el) => {
                    let linksAccordion = el.querySelector('.ap_links-accordion');
                    if(linksAccordion){
                        let item = el.querySelectorAll('p, ul, ol');
                        item.forEach((e) => {
                            let typeEl = e.childNodes[0].nodeType;
                            let idMore = e.querySelector('[id*="more-"]');
                            let parent = e.parentNode;
                            let accordion = parent.querySelector('.ap_content-more');
                            if((typeEl === 8 || idMore) && !accordion){
                                let contentMore = document.createElement('div');
                                contentMore.classList.add('ap_content-more');
                                e.parentNode.insertBefore(contentMore, e);
                                e.remove();
                            }
                            if(accordion){
                                accordion.appendChild(e);
                            }
                        });

                        let openAccordion = linksAccordion.querySelector('.ap_open-accordion');
                        let closeAccordion = linksAccordion.querySelector('.ap_close-accordion');

                        openAccordion.addEventListener('click', (e) => {
                            e.preventDefault();
                            let parent = e.currentTarget.parentNode;
                            let textWidget = e.currentTarget.parentNode.parentNode;
                            let contentAccordion = textWidget.querySelector('.ap_content-more');
                            contentAccordion.classList.add('active');
                            contentAccordion.style.height = "auto";
                            let height = contentAccordion.clientHeight + "px";
                            contentAccordion.style.height = "0px";
                            setTimeout(() => {
                                contentAccordion.style.height = height;
                            }, 0);

                            e.currentTarget.style.display = 'none';
                            parent.querySelector('.ap_close-accordion').style.display = 'inline-block';
                        });
                        closeAccordion.addEventListener('click', (e) => {
                            e.preventDefault();
                            let parent = e.currentTarget.parentNode;
                            let textWidget = e.currentTarget.parentNode.parentNode;
                            let contentAccordion = textWidget.querySelector('.ap_content-more');
                            contentAccordion.classList.remove('active');
                            contentAccordion.style.height = "0px";

                            e.currentTarget.style.display = 'none';
                            parent.querySelector('.ap_open-accordion').style.display = 'inline-block';
                        });
                    }
                });
            },

            stickyButtonLp(){
                if(window.innerWidth <= this.xs_brk) {
                    let btn = $('.header-lp .btn-scroll-to-element');
                    if(btn.length > 0){
                        $(window).on('load scroll', function(){
                            let heightView = $(window).innerHeight();
                            let distanceForm = $('#' + btn.attr('data-scrolltoelement')).offset().top - heightView;
                            if (window.pageYOffset > distanceForm) {
                                btn.addClass("d-none");
                            } else {
                                btn.removeClass("d-none");
                            }
                        });
                    }
                }
            },

            svgMask(){
                if($('.ap_img-mask').length > 0){
                    $('.ap_img-mask').each(function(){
                        var svg_height = $(this).find('.ap_svg-mask').height();
                        $(this).find('.vc_single_image-img').css('height', svg_height);
                    });
                }
            },

            languagePopup(){
                let popupClass = document.getElementsByClassName('ap_language-popup');
                let popup = document.querySelector('.ap_language-popup');
                if(popupClass.length > 0 && ApCore.ApGetCookie("languagePopup") !== 'true'){
                    popup.classList.add('ap-fadeInUp', 'visible');
                }
                let btn = document.querySelectorAll('.ap_close-language-popup, .ap_btn-current-lang');
                btn.forEach(item => {
                    item.addEventListener('click', () => {
                        popup.classList.add('ap-fadeOutDown', 'no-interaction');
                        ApCore.ApSetCookie("languagePopup", 'true', 365);
                    }, false);
                });
            },

            collectionsAjaxTab(){
                let $collection_wrap = $('.ap_ajax_tab');
                if($collection_wrap.length > 0){
                    let order = 0;
                    let row_offset_top = 0;
                    let $items = $collection_wrap.find('.col-term');
                    let content_tab = $('.content-tab-term');
                    $items.each(function(i,el) {
                        let $this = $(el);
                        $this.css('order', order);
                        order++;
                    });
                    $items.each(function(i,el){
                        let $this = $(el);
                        let offset_top = $this.offset().top;
                        if(offset_top > row_offset_top){
                            $this.addClass('first-of-row');
                        }
                        row_offset_top = offset_top;
                    });
                    content_tab.each(function(i,el) {
                        let $this = $(el);
                        let tab_order = $this.nextAll('.first-of-row').css('order');
                        if(!tab_order){
                            tab_order = parseInt($this.prev('.col-term').css('order')) + 10;
                            $this.addClass('last-row');
                        }
                        $this.css('order', tab_order);

                    });
                }
            },

            topBarManager(){
                let topBar = document.getElementById('top-bar');
                if($('#banner-top-header').length > 0){
                    topBar.style.height = topBar.offsetHeight+'px';
                    let topBanner = document.getElementById('banner-top-header');
                    var icon = document.createElement('i');
                    icon.classList.add('icon-close');
                    icon.setAttribute('id','close-top-bar');
                    topBanner.appendChild(icon);

                    if(ApCore.ApGetCookie("topBar") === 'true'){
                        topBar.classList.add('d-none');
                    }
                    let close = document.getElementById('close-top-bar');
                    close.addEventListener('click', () => {
                        this.wrapper.style.transition = '0.3s ease-out';
                        this.wrapper.style.paddingTop = this.header.offsetHeight - topBar.offsetHeight +'px';
                        setTimeout(() =>{
                            this.wrapper.style.transition = '';
                        }, 300)
                        topBar.style.height = '0';
                        ApCore.ApSetCookie("topBar", 'true', 1);
                    }, false);
                }
            },

            search(){
                let searchImput = document.querySelectorAll('.proinput .orig');
                searchImput.forEach(item => {
                    item.value = '';
                });
            },

            mobileSearch(){
                let btnSearch = document.querySelector('.open-search-box');
                btnSearch.addEventListener('click', (e) => {
                    let el = e.currentTarget
                    el.classList.toggle('active');

                    let searchBar = document.querySelector('#header-nav .ap_mobile-search');
                    if(searchBar.classList.contains('ap-fadeInDown')){
                        searchBar.classList.add('ap-fadeOutUp')
                        searchBar.classList.remove('ap-fadeInDown', 'active');
                    } else{
                        searchBar.classList.remove('ap-fadeOutUp')
                        searchBar.classList.add('ap-fadeInDown', 'active');
                    }


                    if(el.classList.contains('active')){
                        setTimeout(function(){
                            document.querySelector('#header-nav .wpdreams_asl_container .orig').click();
                        }, 300);
                    }
                });
            },

            newsletterManager(){
                let nlEmail = document.querySelector('.ap_nl-email');
                if(nlEmail){
                    let nlInputEmail = nlEmail.querySelector('input');
                    let form = nlEmail.parentNode.parentNode.parentNode;
                    nlInputEmail.addEventListener('focus', () => {
                        form.classList.add('form-expanded');
                    });
                    let input = document.querySelectorAll('.ap_nl-email, .ap_hidden-field');
                    input.forEach(item => {
                        if(item.classList.contains('gfield_error')){
                            form.classList.add('form-expanded');
                        }
                    });
                }
            },

            apTableManager(){
                if (window.innerWidth <= 1024) {
                    $('table').wrap('<div class="ap-table-wrapper"><div class="ap_container-table"></div></div>');
                    $('.ap-table-wrapper').each(function (index, el) {
                        if ($(this).innerWidth() < el.scrollWidth) {
                            el = $(el);
                            el.scrollLeft(0);
                            el.append('<div class="darrow danimated dbounce"><i class="icon-chevron-right"></i></div>');
                            $(window).scroll(function () {
                                var darrow_topVal = 0;
                                if ($(window).scrollTop() > el.offset().top) {
                                    darrow_topVal = $(window).scrollTop() - el.offset().top + 20;
                                } else {
                                    darrow_topVal = 20;
                                }
                                el.find('i').css('top', darrow_topVal + 'px');
                            });
                            el.scroll(function () {
                                $(this).find('.darrow').hide();
                            });
                        }
                    });
                }
            },

        };

        AdvivaPress.init();

        let body = jQuery('body');

        jQuery(window).on('load scroll resize', function (e) {
            if (e.type === 'load') {
                body.trigger('advivapress.window.finalize');
            }
            if (e.type === 'scroll') {
                jQuery('body').trigger('advivapress.window.scroll');
            }
            if (e.type === 'resize') {
                jQuery('body').trigger('advivapress.window.resize');
            }
        });
    },
    finalize() {
        jQuery('body').trigger('advivapress.finalize');
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./_project/scripts/routes/common.js